import React from 'react';
import { Link } from 'react-router-dom';
import useNavigation from '@hooks/useNavigation';
import useTranslationLgs from '@hooks/i18n/useTranslation';

interface ComponentProps {
  groupDemandId: string;
  groupDemandName?: string;
  /** When true the name links to the group-demand detail; otherwise it renders as plain text. */
  linked?: boolean;
}

/**
 * Compact "group demand" badge linking to a group-demand detail.
 * Light-orange pill with a gray label and an orange (optionally linked) name.
 */
const GroupDemandBadge: React.FC<ComponentProps> = ({ groupDemandId, groupDemandName, linked = true }) => {
  const { tr } = useTranslationLgs();
  const navigation = useNavigation();

  return (
    <div className="px-2 py-1 bg-[#ffeee5] rounded text-sm inline-flex flex-wrap w-fit mt-2">
      <span className="text-gray-600">{tr('SupplierNotificationList.groupDemand', 'Hromadná poptávka')}</span>
      {linked ? (
        <Link to={navigation.createNavigationLink(navigation.urlFunctions.createMultiDemanDetail(groupDemandId))}>
          <span className="font-medium hover:text-orange-800 ml-1">{groupDemandName}</span>
        </Link>
      ) : (
        <span className="font-medium ml-1">{groupDemandName}</span>
      )}
    </div>
  );
};

export default GroupDemandBadge;